import React, { useContext } from 'react';
import { Trans } from '@lingui/react';
import { ThemeContext } from 'styled-components';
import { StyledMaterialButton } from '@components/buttons';
import TextWithIcon from '@components/TextWithIcon';
import Spinner from './Spinner';
import { VideoFavoriting } from '@ecosystems/Favoriting';
import { UserContext } from '@lib/contexts/UserProvider';
import useLoginModal from '@lib/hooks/useLoginModal';

const ButtonFavoriteVideoCard = props => {
  const [modal, { openModal }] = useLoginModal();
  const theme = useContext(ThemeContext);
  const [currentUser, { loading: userLoading }] = useContext(UserContext);

  const handleFavoriting = async onClickFavoriteHandler => {
    if (currentUser?.id) {
      await onClickFavoriteHandler();
    } else {
      openModal();
    }
  };

  return (
    <VideoFavoriting videoId={props.videoId}>
      {({ isFavoritedVideoById, onClickFavoriteHandler, loading }) => (
        <>
          <StyledMaterialButton
            onClick={() => handleFavoriting(onClickFavoriteHandler)}
            {...(loading || userLoading ? { disabled: true, loading } : {})}
            data-testid="VideoCard--FavoriteButton"
          >
            {loading ? (
              <>
                <Spinner
                  style={{ padding: '10px' }}
                  size={10}
                  spinnerColor="#7d7d7d"
                />
                {isFavoritedVideoById ? (
                  <Trans
                    id="metadata.saved_favorites"
                    message="Saved to favorites"
                  />
                ) : (
                  <Trans
                    id="metadata.save_favorites"
                    message="Save to favorites"
                  />
                )}
              </>
            ) : (
              <TextWithIcon
                icon={
                  isFavoritedVideoById
                    ? 'ygb-icon-heart-filled'
                    : 'ygb-icon-heart-outline'
                }
                iconColor={
                  isFavoritedVideoById
                    ? theme.colors.primary['blue-2']
                    : theme.colors.neutrals.black
                }
                iconSize={'15px'}
                uppercase
              >
                {isFavoritedVideoById ? (
                  <Trans
                    id="metadata.saved_favorites"
                    message={`Saved to favorites`}
                  />
                ) : (
                  <Trans
                    id="metadata.save_favorites"
                    message={`Save to favorites`}
                  />
                )}
              </TextWithIcon>
            )}
          </StyledMaterialButton>
          {modal}
        </>
      )}
    </VideoFavoriting>
  );
};

export default ButtonFavoriteVideoCard;
